module.exports = __webpack_public_path__ + "img/k1.6feb21bf.webp";